module.exports = __webpack_public_path__ + "img/express-flower-gel-double-tensor-7-medium@2x.be90632c.png";